// Tag input start
import { appShadowRoot } from '../../common/elements';
import { log } from '../../common/log';
import {notice} from '../../common/notice';
import {getLabel} from '../../common/labels';


const TagsInput = function (opts) {
  this.options = Object.assign(TagsInput.defaults, opts);
  console.log('line 10');
  
  this.init();
};

// Private function to initialize the tag input plugin
function initTagsInputPlugin (tagsPlugin) {
  tagsPlugin.wrapper.append(tagsPlugin.input);
  tagsPlugin.wrapper.classList.add(tagsPlugin.options.wrapperClass);
  tagsPlugin.wrapper.setAttribute('data-cs-mask', '');
  tagsPlugin.orignal_input.setAttribute('hidden', 'true');
  tagsPlugin.orignal_input.parentNode.insertBefore(tagsPlugin.wrapper, tagsPlugin.orignal_input);
}
export const seprateEmails = async function (str, tagsPlugin) {
  let errorMessage = '';
  const tagsInputWrapper = appShadowRoot.querySelector('.tags-input-wrapper');
  const copiedEmails = str.split(',').map(email => email.trim()).filter(email => email.length > 0);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const invalidEmails = [];
  if (tagsInputWrapper) {
    const input = appShadowRoot.querySelector('.tags-input-wrapper input');
    copiedEmails.forEach(email => {
      if (!emailRegex.test(email)) {
        invalidEmails.push(email);

        return;
      }
      const emailExists = Array.from(
        tagsInputWrapper.querySelectorAll('.tag')
      ).some(tag => tag.textContent.trim() === email);
      if (!emailExists) {
        tagsPlugin.addTag(email, false);
      } else {
        errorMessage = getLabel('This email has already been added.');
        notice(errorMessage, true, 3000, 'negative', 0, true);
      }
    });
    if (invalidEmails.length > 0) {
      errorMessage = getLabel('Invalid Email: ' + invalidEmails.join(', '));
      notice(errorMessage, true, 3000, 'negative', 0, true);
    }
    input.value = '';
  }
};

// initialize the Events
function initEvents(tagsPlugin) {
  tagsPlugin.wrapper.addEventListener('click', () => {
    tagsPlugin.input.focus();
  });
  tagsPlugin.input.addEventListener('keydown', async (e) => {
    const str = tagsPlugin.input.value.trim();
    if (~[9, 13, 188].indexOf(e.keyCode)) {
      e.preventDefault();
      tagsPlugin.input.value = '';
      if (str !== '') {
        await seprateEmails(str, tagsPlugin);
      }
    } else if (e.key === 'Backspace' || e.keyCode === 8) {
      if (!tagsPlugin.input.value.length) {
        const tags = tagsPlugin.wrapper.querySelectorAll('.tag');
        if (tags.length > 0) {
          e.preventDefault();
          const lastTag = tags[tags.length - 1];
          tagsPlugin.deleteTag(lastTag);
          tagsPlugin.input.focus();
        }
      }
    }
  });

  tagsPlugin.input.addEventListener('blur', (e) => {
    var str = tagsPlugin.input.value.trim();
    e.preventDefault();
    tagsPlugin.input.value = '';
    const regexEmail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    if (str !== '') {
      const dropdown = appShadowRoot.querySelector('.watcher-drop');
      if (dropdown) {
        return;
      }
      if (regexEmail.test(str) === false) {
        tagsPlugin.addTag(str, true, tagsPlugin);
      } else {
        tagsPlugin.addTag(str, false);
        // tags.addTagToDataValue(str);
      }
    }
  });
}

// Initialize the plugin
TagsInput.prototype.init = function (opts) {
  try{

    this.options = opts ? Object.assign(this.options, opts) : this.options;
    
    if (this.initialized) {
      this.destroy();
    }
    
    if (!(this.orignal_input = appShadowRoot.getElementById(this.options.selector))) {
      return this;
    }
    console.log('line 107');
    
    this.arr = [];
    this.wrapper = document.createElement('div');
    this.input = document.createElement('input');
    this.input.setAttribute('data-cs-mask', '');
    const originalPlaceholder = this.orignal_input.getAttribute('placeholder');
    if (originalPlaceholder) {
      this.input.setAttribute('placeholder', originalPlaceholder);
    }
    initTagsInputPlugin(this);
    initEvents(this);
    this.initialized = true;
    
    return this;
  } catch(error){
    console.error('error', error);
    
  }
};

TagsInput.prototype.addTagToDataValue = function (string) {
  const tagElement = appShadowRoot.querySelector(`#${this.options.selector}`);
  tagElement.setAttribute('data-value', tagElement.getAttribute('data-value') + string + ',');
};

// Add Tags
TagsInput.prototype.addTag = function (string, error, tagsPlugin) {
  if (this.anyErrors(string)) {
    return;
  }
  // var tagInput = this;

  var tag = document.createElement('span');
  if (error === false) {
    this.arr.push(string);
    tag.className = this.options.tagClass;
    const tagElement = appShadowRoot.querySelector(`#${this.options.selector}`);
    tagElement.setAttribute('data-value', tagElement.getAttribute('data-value') + string + ',');
    tag.innerText = string;
    this.wrapper.insertBefore(tag, this.input);
    this.orignal_input.value = this.arr.join(',');
  } else {
    seprateEmails(string, tagsPlugin);
  }

  return this;
};

// Delete Tags
TagsInput.prototype.deleteTag = function (tag, i) {
  tag.remove();
  this.arr.splice(i, 1);
  this.orignal_input.value = this.arr.join(',');
  const tagElement = appShadowRoot.querySelector(`#${this.options.selector}`);
  tagElement.setAttribute('data-value', '');
  const tagArray = [];
  const regexEmail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  this.arr.forEach(str => {
    if (str !== '') {
      if (regexEmail.test(str) === true) {
        tagArray.push(str);
      }
    }
  });
  tagElement.setAttribute('data-value', tagArray.toString() + ',');

  return this;
};

// Make sure input string have no error with the plugin
TagsInput.prototype.anyErrors = function (string) {
  if (this.options.max !== null && this.arr.length >= this.options.max) {
    log('Max tags limit reached');

    return true;
  }
  if (!this.options.duplicate && this.arr.indexOf(string) !== -1) {
    log(`Duplicate found " ${string} "`);

    return true;
  }

  return false;
};

// Get the Input String
TagsInput.prototype.getInputString = function () {
  return this.arr.join(',');
};
// destroy the plugin
TagsInput.prototype.destroy = function () {
  this.orignal_input.removeAttribute('hidden');
  delete this.orignal_input;
  const self = this;
  Object.keys(this).forEach((key) => {
    if (self[key] instanceof HTMLElement) {
      self[key].remove();
    }
    if (key !== 'options') {
      delete self[key];
    }
  });
  this.initialized = false;
};

// Set All the Default Values
TagsInput.defaults = {
  selector: '',
  wrapperClass: 'tags-input-wrapper',
  tagClass: 'tag radius-5 is-size-7	mr-1',
  taghasError: 'tag radius-5 is-size-7 mr-1 border-red',
  max: null,
  duplicate: false
};
window.TagsInput = TagsInput;

export const instantiateTagsInput = function (element) {
  console.log('element', element);
  
  return new TagsInput({
    selector: element,
    duplicate: false,
    max: 100
  });
};
